import { ErrorLike } from "@apollo/client"
import { useQuery } from "@apollo/client/react"
import { getUserDataSourceQuery } from "../../../queries/__generated-typings__/getUserDataSource"
import { getUserDataSource } from "../../../queries/getUserDataSource"
import { useUserBehaviours } from "../../../hooks/useUserBehaviours"

type PrivacyPolicyResponse = {
  data: {
    id: string | null
    askToReadPrivacyPolicy: boolean
  }
  error: ErrorLike | undefined
  loading: boolean
}

export const useUserPrivacyPolicy = (): PrivacyPolicyResponse => {
  const {
    data: userData,
    error: errorUserData,
    loading: loadingUserData
  } = useQuery<getUserDataSourceQuery>(getUserDataSource)

  const userId = userData?.credimi_futuro_dossiers_view[0]?.company?.profiles[0]?.contact?.sfid

  const { userBehaviours, error, loading } = useUserBehaviours(userId, "privacy_policy_and_terms_conditions")

  if (userData?.credimi_futuro_dossiers_view && userBehaviours) {
    const hasReadPrivacyPolicy = userBehaviours.user_behaviours?.find(el => el?.value === "true")

    const isApplicationPartner = !!userData?.credimi_futuro_dossiers_view.find(
      el => el.application_source?.toLocaleLowerCase() === "partner"
    )

    const askToReadPrivacyPolicy = isApplicationPartner && !hasReadPrivacyPolicy

    return {
      data: {
        id: userData?.credimi_futuro_dossiers_view[0]?.company?.profiles[0]?.contact?.sfid || null,
        askToReadPrivacyPolicy
      },
      error: error || errorUserData,
      loading: loading || loadingUserData
    }
  }

  return {
    data: { id: null, askToReadPrivacyPolicy: false },
    error: error || errorUserData,
    loading: loading || loadingUserData
  }
}
